import { DayOfWeekEnum } from '../../../shared/enums/day-of-week.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';

/**
 * Proto settings DTO
 * @description
 * IMPORTANT: This DTO must not contain any sensitive data like API keys, passwords, contact information, etc.
 * It is exposed to the client on an API endpoint that is not protected by authentication for READ access.
 */
@CaslSubject(AppSubjectEnum.SETTINGS)
export class ProtoSettingsDto extends BaseProtoDto {
	shortDateFormat?: string;
	shortTimeFormat?: string;
	longDateFormat?: string;
	longTimeFormat?: string;
	firstDayOfWeek?: DayOfWeekEnum;

	amountDecimalDigits?: number;
	amountDecimalSeparator?: string;
	amountGroupSeparator?: string;
}
